/* istanbul ignore file */
export * from './SearchResultPageDefaultContent';
